import Vue from 'vue'

const state = {
  debiteuren: []
}

const getters = {
  debiteuren: (state) => state.debiteuren
}

const actions = {
  async getDebiteuren ({commit, getters}, force = false) {
    if (getters.debiteuren.length > 0 && !force) {
      return
    }

    const {body} = await Vue.http.get('/debiteuren')
    commit('setDebiteuren', body.data)
  },
  async syncDebiteuren ({dispatch}) {
    await Vue.http.post('/sync/debiteuren')
    await dispatch('getDebiteuren', true)
  }
}

const mutations = {
  setDebiteuren (state, debiteuren) {
    state.debiteuren = debiteuren
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/debiteuren.js